import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type InternalNotificationSettingsPageType from './index.tsx';

export const LazyInternalNotificationSettingsPage = lazyForPaint<
	typeof InternalNotificationSettingsPageType
>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-notification-internal-settings-page" */ './index'
		),
);
